<div class="segment-wrapper" [class.lang-en]="languageService.userLanguage === 'en'">
    <div class="segment" [class.inline]="inline" [class.incols]="!inline">
        <div class="date">
            <div>
                {{ segmentItem.begin | dateMoment: dateService.dateFormats.momentMedium }}
                <sup *ngIf="beginDaysDifference && beginDaysDifference > 0" class="beginDaysDifference">
                    {{completeLabel(wording.jPlus, toString(beginDaysDifference))}}
                </sup>
                <sup *ngIf="beginDaysDifference && beginDaysDifference < 0" class="beginDaysDifference">
                    {{completeLabel(wording.jMoins, toString(beginDaysDifference))}}
                </sup>
            </div>
        </div>

        <div class="fromto">
            <fa-icon class="left_ico" *ngIf="displayBan" [size]="iconSize" [icon]="iconBan"></fa-icon>
            <div class="fromto-part from">
                <div class="airport">{{ segmentItem.from }}</div>
                <div *ngIf="type !== 'sectorListTitle' && type !== 'journeyList'">
                    <em>{{ segmentItem.begin | dateMoment: dateService.dateFormats.momentTime }}</em>
                </div>
            </div>
            <fa-icon [icon]="iconArrowRight" class="icon-arrow-right icon"></fa-icon>
            <div class="fromto-part to">
                <span class="airport">{{ segmentItem.to }}</span>
                <br *ngIf="type != 'sectorListTitle' && type != 'journeyList'">
                <em *ngIf="type != 'sectorListTitle' && type != 'journeyList'">
                    {{ segmentItem.end | dateMoment: dateService.dateFormats.momentTime }}
                    <sup *ngIf="dayDiff" class="small">{{dayDiff}}</sup>
                </em>
            </div>

        </div>

        <div class="carrier" *ngIf="type !== 'sectorListTitle' && type !== 'journeyList'" [class.has-logo]="logosUrl">
            <ng-container
                    *ngFor="let segmentCarrier of segmentItem.carrier; let lastItem = last; let codeIndex = index ">
                <ng-container *ngIf="!showImage[codeIndex]">{{segmentCarrier.code}}</ng-container>
                <ng-container *ngIf="logosUrl">
                    <img class="air-logo"
                         [attr.src]="logosUrl + segmentCarrier.code + '.png' | urlAddDomain"
                         [hidden]="!showImage[codeIndex]"
                         [attr.alt]="segmentCarrier.code"
                         [attr.title]="segmentCarrier.code"
                         (error)="showImage[codeIndex] = false"
                         (load)="showImage[codeIndex] = true">
                </ng-container>
                <fa-icon *ngIf="segmentCarrier.preferred" [icon]="iconStar"></fa-icon>
                <div *ngIf="isFareSentinel">
                    <fa-icon
                            cdkOverlayOrigin
                            #trigger="cdkOverlayOrigin"
                            [icon]="iconHeart"
                            class="icon-heart"
                            size="xs"
                            (mouseenter)="isTooltipVisible = true"
                            (mouseleave)="isTooltipVisible = false"
                    ></fa-icon>
                    <ng-template
                            cdkConnectedOverlay
                            [cdkConnectedOverlayOrigin]="trigger"
                            [cdkConnectedOverlayOpen]="isTooltipVisible">
                        <div class="tooltip">{{ wording.fareSentinel }}</div>
                    </ng-template>
                </div>
                <span *ngIf="!lastItem && !showImage[codeIndex]"> / </span>
            </ng-container>
        </div>
        <div *ngIf="type !== 'journeyList'" [class.info]="type !=='sectorListTitle'">
            <div>
                <div *ngIf="segmentItem.duration" class="e2e-travel-time">
                    <fa-icon [icon]="iconClock"></fa-icon>
                    {{ segmentItem.duration.minutes | duration }}
                </div>
                <ng-container *ngIf="luggages?.length">
                    <luggage *ngFor="let luggageItem of luggages" [restriction]="luggageItem.restriction"
                             [type]="luggageItem.in" [inline]="!inline"></luggage>
                </ng-container>
                <div *ngIf="!inline">
                    <stops [nbStops]="nbStops"></stops>
                    <fare-family *permissionIf="alternativesPermission"
                                 [fareFamily]="segmentFareFamily"
                                 [fareFamilyDictionary]="fareFamilyDictionary"
                                 [sector]="segmentItem.sector"></fare-family>
                    <div class="carbon-footprint">
                        <carbon-footprint [carbonValue]="segmentItem.carbonFootprint"></carbon-footprint>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="type === 'journeyList'" class="space">&nbsp;</div>

        <div class="escale" *ngIf="type !== 'journeyList' && inline">
            <stops [nbStops]="nbStops"></stops>
            <fare-family *permissionIf="alternativesPermission"
                         [fareFamily]="segmentFareFamily"
                         [fareFamilyDictionary]="fareFamilyDictionary"
                         [sector]="segmentItem.sector"></fare-family>
            <div class="carbon-footprint">
                <carbon-footprint [carbonValue]="segmentItem.carbonFootprint"></carbon-footprint>
            </div>
        </div>

    </div>
</div>
